export default __webpack_public_path__ + "static/media/spinner50.9cf73202.svg";